/**
 * Shared constants used across vendor, promoter, and prospect forms
 */

export const INDUSTRY_SECTORS = [
  'Information Technology',
  'Finance',
  'Education',
  'Healthcare',
  'Manufacturing',
  'Retail',
  'Real Estate',
  'Construction',
  'Transportation',
  'Energy',
  'Telecommunications',
  'Media',
  'Entertainment',
  'Hospitality',
  'Agriculture',
  'Consulting',
  'Legal',
  'Logistics',
  'Automotive',
  'Pharmaceuticals',
  'Biotechnology',
  'Aerospace',
  'Defense',
  'Government',
  'Non-Profit',
  'Other'
] as const;

export type IndustrySector = typeof INDUSTRY_SECTORS[number];

export const DEFAULT_INDUSTRY_SECTORS: readonly string[] = INDUSTRY_SECTORS.slice(0, 10);
